import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";

import "../../assets/css/error.css";

export default class ErrorPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="errorpage">

        <div
          style={{
            position: "absolute",
            width: "50vw",
            height: "50vh",
            top: "30%",
            left: "30%",
          }}
        >
          <div id="errormsgbox">
            <div id="errorLabel" style={{ color: "lightgrey" }}>
              The System generated an Unexpected Error
            </div>
            <div id="errorMsg" style={{ color: "yellow" }}>
              {this.props.systemErrorMsg}
            </div>
            <div id="authButtonLayer" style={{ alignContent: "center" }}>
              <br />
              <br />
              <Button
                id="authButton"
                onClick={(e) => this.props.onLogoutRequest(e)}
              >
                <FontAwesomeIcon icon={faPowerOff} color="yellow" />
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
